import { render, staticRenderFns } from "./InterfaceAttachment.vue?vue&type=template&id=20c650d4"
import script from "./InterfaceAttachment.vue?vue&type=script&lang=js"
export * from "./InterfaceAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports